"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ieZones = void 0;
var ieZones = exports.ieZones = [{
  id: 'DUBLIN',
  name: 'Dublin',
  country: 'IE',
  cornerNW: {
    latitude: 53.4345,
    longitude: -6.3853
  },
  cornerSE: {
    latitude: 53.2684,
    longitude: -6.1134
  },
  subZones: [{
    name: 'Dublin Centre historique',
    zipcodes: {
      D01: {
        label: 'D01'
      }
    }
  }, {
    name: 'Dublin Quartier gouvernemental',
    zipcodes: {
      D02: {
        label: 'D02'
      }
    }
  }, {
    name: 'Dublin Rathmines',
    zipcodes: {
      D04: {
        label: 'D04'
      }
    }
  }, {
    name: 'Dublin Blackrock',
    zipcodes: {
      D06: {
        label: 'D06'
      }
    }
  }, {
    name: 'Dublin Tallaght',
    zipcodes: {
      D24: {
        label: 'D24'
      }
    }
  }]
}];